import * as React from "react";
import { AmbientBackground } from "@/components/landing";
import { AuthCard, ResetPasswordForm } from "@/components/auth";

export function ResetPasswordPage() {
  return (
    <div className="relative min-h-screen flex items-center justify-center p-4">
      <AmbientBackground />

      <AuthCard
        title="Set new password"
        description="Your new password must be at least 8 characters"
      >
        <ResetPasswordForm />
      </AuthCard>
    </div>
  );
}

export default ResetPasswordPage;
